import { useGetLearningActivityDraftByIdQuery } from '@hendrx/core/learningActivity/queries/getLearningActivityDraftById';
import { LearningObjectTypes } from '@hendrx/lms/constants';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { LEARNING_ACTIVITY_PLAYER_PATH, PLENARY_PLAYER_PATH } from 'shared/common/consts/paths';
import { CustomLoadingOverlay } from 'shared/components/app/CustomLoadingOverlay';

export const Route = createFileRoute('/player/$learningObjectDraftId')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      mode: (search.mode as string | undefined) || undefined
    };
  },
  component: RedirectPage
});

function RedirectPage() {
  const { learningObjectDraftId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();

  const { data: draft, isLoading } = useGetLearningActivityDraftByIdQuery(learningObjectDraftId);

  useEffect(() => {
    if (isLoading) return;

    const searchParams = search.mode ? `?mode=${search.mode}` : '';

    if (draft && draft.type === LearningObjectTypes.LearningActivity) {
      void navigate({
        to: `${LEARNING_ACTIVITY_PLAYER_PATH}/${learningObjectDraftId}${searchParams}`,
        replace: true
      });
    } else {
      void navigate({
        to: `${PLENARY_PLAYER_PATH}/${learningObjectDraftId}${searchParams}`,
        replace: true
      });
    }
  }, [navigate, learningObjectDraftId, draft, isLoading, search.mode]);

  return <CustomLoadingOverlay visible />;
}
